import Videoarchive from "./vue/videoarchive.vue";
import Some from "./vue/someshare.vue";
import Vue from "vue";
import navigation from "./general/navigation";
import cta from "./general/cta";
import cookies from "./general/cookies";



  window.addEventListener("DOMContentLoaded", () => {
    navigation();
    cta();
    cookies();
    // Create Vue app with props for video archive
    if (document.querySelector("#videoarchive")) {
      new Vue({
          el: "#videoarchive",
          components: {
            Videoarchive
          }
      });
    }

    // Create Vue app with props for someshare
    if (document.querySelector("#someshare")) {
      new Vue({
          el: "#someshare",
          components: {
            Some
          }
      });
    }
/*
      if (document.querySelector("#test")) {
        new Vue({
            render: h => h(Test)
        }).$mount("#test");
    }*/
  });
